import React from "react"
import { Button, Result } from "antd"

/*
  Ilova darajasidagi xato chegarasi. Ilgari bitta ustun renderida
  null qiymat (masalan, skladda address=null) butun tizimni OQ EKRAN
  qilib qo'yardi — React 17 error boundary bo'lmasa daraxtni to'liq
  o'chiradi. Endi xato o'rniga qayta yuklash tugmasi chiqadi.
*/
export default class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { error: Error | null }
> {
  state = { error: null as Error | null }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error, info: any) {
    // eslint-disable-next-line no-console
    console.error("UI xatosi:", error, info?.componentStack)
  }

  render() {
    if (this.state.error) {
      return (
        <Result
          status="error"
          title="Sahifada xatolik yuz berdi"
          subTitle={String(this.state.error?.message || this.state.error).slice(0, 200)}
          extra={
            <Button type="primary" onClick={() => window.location.reload()}>
              Qayta yuklash
            </Button>
          }
        />
      )
    }
    return this.props.children as any
  }
}
